import { render, staticRenderFns } from "./HorizontalTimeLine.vue?vue&type=template&id=082b531c&scoped=true&"
import script from "./HorizontalTimeLine.vue?vue&type=script&lang=js&"
export * from "./HorizontalTimeLine.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalTimeLine.vue?vue&type=style&index=0&id=082b531c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082b531c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
